import selectModel from "./model"

// Same as selectCollections
export default function selectQueries(state, engine, model) {
  const modelState = selectModel(state, engine, model)
  if (!modelState) {
    return null
  }
  const { queries } = modelState

  return queries
}
